export default __webpack_public_path__ + "static/media/HENNESSY_2.5a036300.gif";